<template>
    <QueueDisplay :total="count">
        <template v-slot:icon>
            <FileInvoiceDollar />
        </template>
    </QueueDisplay>
</template>

<script>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import QueueDisplay from '@/components/ui/QueueDisplay.vue'
import FileInvoiceDollar from '@/components/customIcons/FileInvoiceDollar.vue'
import api from '@/api'

export default {
  components:{QueueDisplay,FileInvoiceDollar},
  emits:['count'],
  setup(props, { emit }) {
    const count = ref(0)

  // Watchers
    watch(count, (value) => emit('count', Number(value) || 0), { immediate: true })

    onMounted(()=>{
      getInitialCount()
      joinRoom()
      window.addEventListener('socket_connected', handleReconnect);
      window.addEventListener("vendor_invoices_queue", handleWebSocketData)
    })

    onUnmounted(()=>{
      window.removeEventListener('socket_connected', handleReconnect);
      window.removeEventListener("vendor_invoices_queue", handleWebSocketData)
    })

    const handleWebSocketData = (e)=>{
      const data = Number(e.detail?.data)
      if (isNaN(data)) {
        count.value = 0;
      } else {
        count.value = data
      }
    }

    const joinRoom = ()=>{
      let eventJoin = new CustomEvent("requestRoom", {detail: { route: "vendorInvoices", room: "vendor_invoices_queue" }});
      dispatchEvent(eventJoin);
    }

    const handleReconnect = ()=>{
      joinRoom()
    }

    const getInitialCount = async ()=>{
      await api
      .get("vendorInvoices/openCount")
      .then((res)=>{
        res.data?.data && Number(res.data.data) ? count.value = Number(res.data.data) : null
      })
      .catch((err)=>{
        console.error(err.response?.data?.error || err.message)
      })
    }


    return {
      count
    }
  }
}
</script>

<style scoped>
</style>